<template>
  <div
    class="flex justify-center items-center cursor-pointer mb-3"
    @mouseover="onMouseOver"
    @mouseleave="onMouseLeave"
    @click.stop="onMouseClick"
  >
    <aha-team-avatar
      :name="name"
      :id="id"
      :width="35"
      :height="35"
      :image="getAvatar"
      :isHover="isHover"
      :isActive="isActive"
      class="text-sm"
    />
    <div class="aha-tooltip-customize" v-if="isShowTooltip">
      {{ name }}
    </div>
    <div
      v-if="isShowTooltip"
      class="aha-tooltip-customize--tooltip__tip"
    ></div>
  </div>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      default: '',
    },
    id: {
      type: Number,
      default: 1,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    avtMode: {
      type: String,
      default: 'team',
    },
  },
  data() {
    return {
      isHover: false,
      isShowTooltip: false,
    }
  },

  computed: {
    getAvatar() {
      if (this.avtMode === 'team') return ''
      if (this.$store.state.currentUser && this.avtMode === 'personal') {
        return this.$store.state.currentUser.avatar
      }
      return ''
    },
  },
  mounted() {
  },
  methods: {
    onMouseOver() {
      this.isShowTooltip = true
      if (this.isActive) return
      this.isHover = true
    },
    onMouseLeave() {
      this.isShowTooltip = false
      if (this.isActive) return
      this.isHover = false
    },
    onMouseClick() {
      this.isHover = false
      this.isShowTooltip = false
      this.$emit('handle')
    },
  },
}
</script>
<style scoped lang='scss'>
.aha-tooltip-customize {
  @apply hidden sm:block;
  position: fixed;
  max-width: 20rem;
  max-height: 5rem;
  padding: 0.25rem 0.5rem;
  left: 3.25rem;
  background: #FFFFFF;;
  border-radius: 0.25rem;
  color: black;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.aha-tooltip-customize--tooltip__tip {
  @apply hidden sm:block;
  z-index: 1;
  position: absolute;
  left: 3.25rem;
  width: 6px;
  height: 6px;
  background: #FFFFFF;
  transform: translate(-50%, 0) rotate(45deg);
  border-bottom-right-radius: 2px;
  outline: none;
}
</style>
